import styled from 'styled-components';

import media from '@/styles/media.style';
import { BLACK, WHITE, BG_GRAY, MOBILE_PADDING, PAGE_WIDTH } from '@/styles/variables.style';

export const Wrapper = styled.div`
  margin: 0;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: ${WHITE};
`;

export const YoutubeSectionWrapper = styled.section`
  margin: 0 auto;
  margin: 0 auto 32px;

  max-width: ${PAGE_WIDTH}px;
  width: 100%;

  padding: 0 ${MOBILE_PADDING}px 20px;

  ${media.tabletL`
    margin: 0 auto 50px;
    padding: 0 20px 45px;
  `};
`;

export const YoutubeSection = styled.div``;

export const HeroImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: ${PAGE_WIDTH}px;
  margin: 20px auto 32px;
  padding: 0 ${MOBILE_PADDING}px 20px;
  text-align: center;

  ${media.tabletL`
    margin: 80px auto 50px;
    padding: 0 20px 45px;
  `};
`;

export const HeroImage = styled.img`
  width: 100%;
  height: 100%;
  max-height: 100%;

  ${media.tabletL`
    width: calc(100% - 160px);
  `};
`;

export const Title = styled.h1`
  width: calc(100% - 40px);
  margin: 0;
  color: ${BLACK};
  font-size: 30px;
  line-height: 32px;
  text-align: center;
  letter-spacing: 1px;
  text-transform: uppercase;

  ${media.tabletL`
    width: calc(100% - 160px);
    font-size: 48px;
    line-height: 50px;
  `};
`;

export const SubTitle = styled.div`
  margin: 0 20px 10px 20px;
  font-size: 22px;
  line-height: 26px;
  color: ${BLACK};
  text-align: center;

  ${media.tabletL`
    margin: 40px 80px 25px 80px;
    font-size: 30px;
    line-height: 36px;
  `};
`;

export const TitleText = styled.div`
  margin: 0;
`;

export const Sections = styled.div`
  &.sectionsPart {
    width: 100%;
    max-width: ${PAGE_WIDTH}px;
    margin: 40px auto 0;
    padding: 0 ${MOBILE_PADDING}px 0;

    // デザイン調整のため、この部分のブレイクポイントは tabletP (600px) で設定
    ${media.tabletP`
      margin: 60px 0 0 0;
    `};
  }

  &.sliderPart {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  &.buttonPart {
    width: 100%;
    max-width: ${PAGE_WIDTH}px;
    margin: 0 auto 60px;
    padding: 0 ${MOBILE_PADDING}px 0;

    ${media.tabletL`
      margin: 0 0 100px 0;
    `};
  }
`;

export const SectionWrapper = styled.div`
  width: 100%;
  margin: 0;

  &.sectionsPart {
    margin: 0 0 40px 0;
  }
`;

export const SectionTitle = styled.div`
  width: 100%;
  margin-top: 30px;
  margin-bottom: 20px;
  color: ${BLACK};
  text-align: left;
  font-size: 24px;
  line-height: 26px;

  ${media.tabletL`
    margin-top: 0;
    margin-bottom: 40px;
    font-size: 30px;
    line-height: 32px;
  `};
`;

// デザイン調整 (文字位置) のため、ブレイクポイントを二つ設定した
export const SectionText = styled.div`
  margin: 30px 20px;
  text-align: left;
  font-size: 14px;
  color: ${BLACK};

  ${media.tabletP`
    text-align: center;
  `};

  ${media.tabletL`
    margin: 40px 80px 120px 80px;
    text-align: center;
    font-size: 18px;
  `};
`;

export const SectionDescription = styled.div`
  overflow: hidden;
  width: auto;
  color: ${BLACK};
  text-align: left;
  font-size: 18px;
  line-height: 28px;
`;

export const SectionDescriptionLine = styled.div`
  > p {
    display: block;
    color: ${BLACK};
    text-align: left;
    margin: 0;
    font-size: 14px;
    line-height: 16px;
    word-wrap: break-word;

    ${media.tabletL`
      font-size: 18px;
      line-height: 28px;
    `};
  }

  &.thirdLine {
    > p {
      display: flex;
      flex-direction: column;
      color: ${BLACK};
      margin: 0;
      font-size: 18px;
      line-height: 28px;

      ${media.tabletL`
        font-size: 18px;
        line-height: 28px;
      `};
    }
  }

  table {
    font-size: 14px;
    color: ${BLACK};
    ${media.tabletL`
      font-size: 18px;
    `};
  }

  th {
    width: 50%;
    padding: 10px 10px 10px 0;
    font-weight: 600;
    vertical-align: baseline;
    ${media.tabletL`
      width: 30%;
    `};
  }

  td {
    padding: 10px 0;
    a {
      white-space: pre-wrap;
      word-break: break-all;
    }
  }
`;

export const SectionDescriptionThirdLine = styled.div`
  > p {
    width: 85%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${BLACK};
    text-align: left;
    margin: 0;
    font-size: 14px;
    line-height: 16px;

    ${media.tabletL`
      font-size: 18px;
      line-height: 28px;
    `};
  }
`;

export const SectionImageWrapper = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  margin: 0;

  ${media.tabletL`
    width: 500px;
    order: ${({ left }) => (left ? '0' : '-1')};
  `};
`;

export const SectionTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin-right: 0;
  margin-left: 0;

  ${media.tabletL`
    width: calc(100% - 500px);
    margin-right: ${({ left }) => (left ? '50px' : '0')};
    margin-left: ${({ left }) => (left ? '0' : '50px')};
    order: ${({ left }) => (left ? '-1' : '0')};
  `};
`;

export const SectionImage = styled.img`
  margin: 0;
`;

export const SeeMore = styled.span`
  width: 100%;
  margin: 0;
  padding: 0;
  color: ${BLACK};
  text-decoration: underline;
  cursor: pointer;
  text-align: right;
  font-size: 18px;
  line-height: 20px;
  font-weight: bold;
`;

export const ImageArticleWrapper = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction};

  ${media.tabletL`
    height: auto;
    min-height: 500px;
    margin: 0 80px 80px 80px;
  `};
`;

// デザイン調整のため、この部分のブレイクポイントは tabletP (600px) で設定
export const CarouselWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin: 0;
  margin-bottom: 60px;

  ${media.tabletP`
    height: 700px;
    margin: 60px 0 100px 0;
  `};
`;

export const CarouselContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 25px 0;
  text-align: center;
  width: ${({ width }) => width};
  height: ${({ height }) => height};

  ${media.tabletL`
    margin: 0;
  `};
`;

// Slick スライダー内に配置すると flexbox は inline-block に変換される
export const CarouselContent = styled.div`
  display: flex;
  flex-wrap: nowrap;
  margin: 0;
  ${media.tabletL`
    display: flex !important;
    align-items: center;
  `};
`;

export const CarouselContentImageWrapper = styled.span`
  display: inline-block;
  ${media.tabletP`
    width: 400px;
  `};

  ${media.tabletL`
    width: 400px;
  `};

  ${media.desktop`
    width: 500px;
  `};
`;

export const CarouselContentTextWrapper = styled.span`
  display: inline-block;
  max-height 194px;
  overflow: hidden;

  vertical-align: top;
  margin-top: 20px;
  padding: 0 20px;

  ${media.tabletP`
    width: 400px;
    max-height unset;
    margin-top: 36px;
  `};

  ${media.tabletL`
    width: 400px;
    margin-left: 40px;
    margin-top: 0;
  `};

  ${media.desktop`
    width: 500px;
  `};
`;

// Slick スライダー内に配置すると flexbox が効かないため、table-cell で対応
export const CarouselContentTextContent = styled.div`
  display: table-cell;
  height: ${({ height }) => height};
  text-align: center;
  vertical-align: middle;
`;

export const CarouselContentTitle = styled.div`
  margin-bottom: 20px;
  color: ${BLACK};
  font-size: 24px;
  line-height: 26px;
  text-align: left;

  ${media.tabletL`
    margin-bottom: 45px;
    font-size: 30px;
    line-height: 32px;
  `};
`;

export const CarouselContentDescription = styled.div`
  margin: 0;
`;

export const Hr = styled.div`
  width: 30px;
  height: 2px;
  background: ${BG_GRAY.COMMON_6};
  margin: 0 calc(50% - 15px);
`;

export const CarouselListWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 25px 0;
  text-align: center;
  width: 100%;
  padding: 0 62px;

  ${media.tabletL`
    max-width: ${PAGE_WIDTH}px;
    padding: 0 100px;
    margin: 0 auto;
  `};
`;

// デザイン調整のため、この部分のブレイクポイントは tabletP (600px) で設定
export const CarouselListThumbnail = styled.div`
  width: 100%;
  max-width: 48px;
  height: 60px;
  margin: 0 6px;

  ${media.tabletP`
    margin: 0 10px;
    max-width: 80px;
    height: 92px;
  `};
`;

export const CarouselListThumbnailImage = styled.img`
  width: 48px;
  height: 60px;
  margin: 0;
  padding-bottom: 12px;
  border-bottom: 3px solid ${WHITE};

  ${media.tabletP`
    width: 80px;
    height: 92px;
  `};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0;
`;

export const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 48px;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 2px;
  text-align: center;
  text-transform: uppercase;
  background: ${BLACK};
  color: ${WHITE};

  ${media.tabletL`
    width: 240px;
    height: 60px;
    font-size: 14px;
    line-height: 16px;
  `};
`;

export const MarkdownStyle = styled.div`
  p {
    margin: 0;
    color: ${BLACK};
    font-size: 14px;
    line-height: 21px;
    text-align: left;

    ${media.tabletL`
      font-size: 18px;
      line-height: unset;
    `};
  }
`;

export const PlaceholderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &.parent {
    width: 100%;
    max-width: ${PAGE_WIDTH}px;
    margin: 20px auto 32px;
    padding: 0 ${MOBILE_PADDING}px 20px;

    ${media.tabletL`
      margin: 80px auto 50px;
      padding: 0 20px 45px;
    `};
  }

  &.child {
    width: ${({ placeholderChildWidth }) => placeholderChildWidth};

    ${media.tabletL`
      flex-direction: row;
    `};
  }

  &.slider {
    width: ${({ placeholderChildWidth }) => placeholderChildWidth};
    margin: 0 20px;

    // デザイン調整のため、ブレイクポイントを tabletP (600 px) にしておく
    ${media.tabletP`
      flex-direction: row;
      margin: 0;
    `};
  }

  &.sliderThumbnail {
    width: ${({ placeholderThumbnailWidth }) => placeholderThumbnailWidth};
    margin: 50px 0 40px 0;

    ${media.tabletL`
      margin: 70px 0 100px 0;
    `};
  }

  &.grandchild {
    width: ${({ placeholderGrandchildWidth }) => placeholderGrandchildWidth};
  }

  &.backButton {
    margin: 40px 0 60px 0;

    // デザイン調整のため、ブレイクポイントを tabletP (600 px) にしておく
    ${media.tabletP`
      margin: 100px 0;
    `};
  }
`;



// WEBPACK FOOTER //
// ./src/pages/InspirationPage/ArticlePage.style.js